import { alpha, styled, Theme } from '@mui/material/styles';
import { Box } from '@mui/material';

const FilterButtonText = styled(Box)(() => ({
  display: 'none',
  '@media (min-width:600px)': {
    display: 'inline',
  },
}));

const FilterFormButtons = styled(Box)(() => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '12px',
  margin: '16px 24px',
  '@media (min-width:600px)': {
    margin: '16px 24px',
  },
}));

const filterButton = {
  marginLeft: '8px',
  padding: '6px 16px',

  '@media (max-width:600px)': {
    margin: '0 8px 0 0',
    minWidth: '36px',
    minHeight: '36px',
    borderRadius: '50px',
    padding: 0,
    '& .MuiButton-endIcon': {
      marginLeft: 0,
      marginRight: 0,
    },
  },
  '@media (min-width:600px)': {
    '& .MuiButton-endIcon': {
      marginLeft: '8px',
    },
  },
};

// Mobile/tablet map search: the filter button lives inside the input with the
// primary accent icon, a light tint of the primary color as background, and
// extra spacing from the input's right edge.
const filterButtonInside = (theme: Theme) => ({
  color: theme.palette.primary.main,
  backgroundColor: alpha(theme.palette.primary.main, 0.1),
  boxShadow: 'none',
  marginRight: '8px',
  '&:hover': {
    backgroundColor: alpha(theme.palette.primary.main, 0.2),
    boxShadow: 'none',
  },
});

const filterMenuPopover = {
  padding: 0,
  marginTop: '14px',
  overflowY: 'auto',
  '@media (min-width:600px)': {
    marginTop: '22px',
  },
};

const filterList = {
  width: '100%',
  maxWidth: '300px',
  margin: 0,
  padding: 0,
};

const filterPopoverTitle = {
  fontWeight: 700,
  margin: '16px 24px',
};

const filterListItemBtn = {
  padding: '4px 24px',
};

const filterListItemIcon = {
  minWidth: 0,
};

const filterListLabel = {
  display: 'flex',
  alignItems: 'center',
};

const filterListLabelText = {
  marginLeft: '8px',
};

export {
  FilterButtonText,
  FilterFormButtons,
  filterButton,
  filterButtonInside,
  filterMenuPopover,
  filterList,
  filterPopoverTitle,
  filterListItemBtn,
  filterListItemIcon,
  filterListLabel,
  filterListLabelText,
};
